export function ChannelGroupContainer({ children }: { children: React.ReactNode }) {
    return <div className="flex items-center w-full gap-[8px]">{children}</div>
}
